import {useLocation} from "react-router-dom";
import {isServer} from "../constants/isServer";

const useSSRLocation = () => {
    // Client-side: use the real location
    // if (!isServer) {
    //     return useLocation();
    // }

    // Server-side: return a minimal location object
    return {
        pathname: '',
        search: '',
        hash: '',
        state: null,
        key: ''
    };
};

export default useSSRLocation;import {useLocation} from "react-router-dom";
import {isServer} from "../constants/isServer";

const useSSRLocation = () => {
    // Client-side: use the real location
    // if (!isServer) {
    //     return useLocation();
    // }

    // Server-side: return a minimal location object
    return {
        pathname: '',
        search: '',
        hash: '',
        state: null,
        key: ''
    };
};

export default useSSRLocation;